// @ts-nocheck

import React, { useEffect, useState } from 'react';
import {
  AI_AGENT_DESC_LIMIT_PRESETS,
  DEFAULT_AI_AGENT_DESC_CHAR_LIMIT,
  normalizeAiAgentDescLimitForSave,
} from '@/utilities/aiAgentAcl';
import { AclSettingsModal, AclModalSection, FaFileAlt } from '@/features/acl-settings/aclSettingsUi';

const AiAgentDescLimitAclModal = ({ show, onHide, initialLimit, onSave }) => {
  const [selected, setSelected] = useState(DEFAULT_AI_AGENT_DESC_CHAR_LIMIT);

  useEffect(() => {
    if (show) {
      setSelected(
        AI_AGENT_DESC_LIMIT_PRESETS.includes(Number(initialLimit))
          ? Number(initialLimit)
          : DEFAULT_AI_AGENT_DESC_CHAR_LIMIT,
      );
    }
  }, [show, initialLimit]);

  const handleReset = () => setSelected(DEFAULT_AI_AGENT_DESC_CHAR_LIMIT);

  const handleSave = () => {
    onSave(normalizeAiAgentDescLimitForSave(selected));
    onHide();
  };

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="Ai Agent — Description Character Limit"
      icon={FaFileAlt}
      description="Set how many characters this role can type into Description fields inside the AI Agent builder."
      onSave={handleSave}
      onReset={handleReset}
      size="md"
    >
      <AclModalSection
        icon={FaFileAlt}
        title="Character Limit"
        subtitle="Only one limit can be active at a time."
      >
        <div className="d-flex flex-column gap-2 mt-2">
          {AI_AGENT_DESC_LIMIT_PRESETS.map((limit) => (
            <div key={limit} className="form-check acl-modal-check acl-modal-check--block mb-0">
              <input
                type="checkbox"
                id={`ai-agent-desc-limit-${limit}`}
                className="form-check-input"
                checked={selected === limit}
                onChange={() => setSelected(limit)}
              />
              <label htmlFor={`ai-agent-desc-limit-${limit}`} className="form-check-label">
                <strong>{limit} characters</strong>
                {limit === DEFAULT_AI_AGENT_DESC_CHAR_LIMIT && (
                  <span className="d-block acl-modal-check-desc">Default</span>
                )}
              </label>
            </div>
          ))}
        </div>
      </AclModalSection>
    </AclSettingsModal>
  );
};

export default AiAgentDescLimitAclModal;